import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '~/pages/Supplier/SignIn';
import ForgotPassword from '~/pages/Supplier/ForgotPassword';
import ChangePassword from '~/pages/Supplier/ChangePassword';
import SignUp from '~/pages/Supplier/SignUp';
import Dashboard from '~/pages/Supplier/Dashboard';
import OpenProcesses from '~/pages/Supplier/OpenProcesses';
import ProcessesInProgress from '~/pages/Supplier/ProcessesInProgress';
import FinalizedProcesses from '~/pages/Supplier/FinalizedProcesses';
import Profile from '~/pages/Supplier/Profile';

const ProviderRoutes: React.FC = () => {
  return (
    <Switch>
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/login`}
        exact
        component={SignIn}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/esqueci-minha-senha`}
        exact
        component={ForgotPassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/recuperar-senha/:token`}
        exact
        component={ChangePassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/cadastro`}
        exact
        component={SignUp}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/cadastro/:token`}
        exact
        component={SignUp}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/cadastro/:step`}
        exact
        component={SignUp}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/cadastro/:token/inicio`}
        exact
        component={SignUp}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/cadastro/:token/:step`}
        exact
        component={SignUp}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/dashboard`}
        exact
        isPrivate
        component={Dashboard}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-abertos`}
        exact
        isPrivate
        component={OpenProcesses}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-abertos/:nursery`}
        exact
        isPrivate
        component={OpenProcesses}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-em-andamento`}
        exact
        isPrivate
        component={ProcessesInProgress}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-em-andamento/:nursery`}
        exact
        isPrivate
        component={ProcessesInProgress}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-finalizados`}
        exact
        isPrivate
        component={FinalizedProcesses}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/processos-finalizados/:nursery`}
        exact
        isPrivate
        component={FinalizedProcesses}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/perfil`}
        exact
        isPrivate
        component={Profile}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/prestador/perfil/:step`}
        exact
        isPrivate
        component={Profile}
      />
    </Switch>
  );
};

export default ProviderRoutes;
